import { render, staticRenderFns } from "./GameAlert.vue?vue&type=template&id=c4891ae2&scoped=true"
import script from "./GameAlert.vue?vue&type=script&lang=js"
export * from "./GameAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4891ae2",
  null
  
)

export default component.exports